import $ from 'jquery'

if (document.getElementById('page-top')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  // ヘッダの表示切替
  $(window).on('scroll', () => {
    if ($(window).scrollTop() < $(window).height() * 0.5) {
      $('.header').removeClass('is-hide')
    } else {
      $('.header').addClass('is-hide')
    }
  })

  // MVの画像切り替え
  const $mvIndicatorGage = $('.topMV__indicatorGage')
  const $mvIndicatorNo = $('.topMV__indicatorNo')
  const mvR = $('.topMV__bgPhotos').get(0)
  const mvL = $('.topMV__bgPhotos').get(1)
  const $mvRPhotos = $(mvR).find('.topMV__bgPhoto')
  const $mvLPhotos = $(mvL).find('.topMV__bgPhoto')
  const mvMaxIndex = $mvRPhotos.length
  const timeSlide = 1 // 画像スライドに要する時間
  const timeSwitch = 0.125 // 画像切り替えに要する時間
  const timeTotal = timeSlide + timeSwitch
  let mvCurrent = 0
  let mvProgress = 0
  let mvSpeed = 0.0025
  const updateMV = () => {
    const isSP = $(window).width() <= 768

    // 進捗更新
    mvProgress += mvSpeed
    if (mvProgress >= timeTotal) {
      mvProgress = 0
      mvCurrent = (mvCurrent + 1) % mvMaxIndex
    }

    const perSlide = Math.min(Math.max(mvProgress / timeSlide, 0), 1)
    const perSwitch = Math.min(Math.max((mvProgress - timeSlide) / timeSwitch, 0), 1)

    // 右側は mvCurrent が表示中で、次の画像が待機中
    const rCurrent = mvCurrent
    const rNext = (mvCurrent + 1) % mvMaxIndex

    // 左側は mvCurrent よりも次の画像が表示中で、さらに次の画像が待機中
    const lCurrent = (mvCurrent + 1) % mvMaxIndex
    const lNext = (mvCurrent + 2) % mvMaxIndex

    for (let n = 0; n < mvMaxIndex; n++) {
      /**
       * 右側の処理
       */
      const $rPhoto = $($mvRPhotos[n])
      if (n == rCurrent) {
        $rPhoto.css({ transform: '', zIndex: 0, opacity: 1 })
        if (!isSP) {
          $rPhoto.find('img').css({ transform: `translateX(-${20 * perSlide}rem)` })
        } else {
          $rPhoto.find('img').css({ transform: `translateX(-${7 * perSlide}rem)` })
          //   $rPhoto.find('img').css({ transform: `translateY(-${20 * (1 - perSlide)}rem)` })
        }
      } else if (n == rNext) {
        if (!isSP) {
          $rPhoto.css({
            transform: `translateX(-${100 * (1 - perSwitch)}%)`,
            zIndex: 1,
            opacity: Math.min(perSwitch * 2, 1),
          })
          $rPhoto.find('img').css({ transform: `translateX(0rem)` })
        } else {
          $rPhoto.css({
            transform: `translateY(${100 * (1 - perSwitch)}%)`,
            zIndex: 1,
            opacity: Math.min(perSwitch * 2, 1),
          })
          $rPhoto.find('img').css({ transform: `translateY(0rem)` })
        }
      } else {
        $rPhoto.css('opacity', 0)
      }

      /**
       * 左側の処理
       */
      const $lPhoto = $($mvLPhotos[n])
      if (n == lCurrent) {
        $lPhoto.css({ opacity: 1, zIndex: 0 })
      } else if (n == lNext) {
        $lPhoto.css({ opacity: Math.min(perSwitch * 2, 1), zIndex: 1 })
      } else {
        $lPhoto.css('opacity', 0)
      }
    }

    // インジゲーター
    $mvIndicatorGage.css({ width: `${100 * perSlide}%`, opacity: 1 - perSwitch })
    $mvIndicatorNo.text('0' + (mvCurrent + 1))

    requestAnimationFrame(updateMV)
  }
  updateMV()

  // SERVICEの画像切り替え
  const $serveceImages = $('.topService__image')
  $('.js-service-link')
    .on('mouseover', (e) => {
      const no = $(e.target).data('no') - 1
      $($serveceImages[no]).addClass('is-show')
    })
    .on('mouseout', (e) => {
      const no = $(e.target).data('no') - 1
      $($serveceImages[no]).removeClass('is-show')
    })

  // WORKSの画像スライダー
  const $worksSlider = $('.topWorks__bgInner')
  let worksSliderX = 0
  const updateWorksSlider = () => {
    worksSliderX += 0.05
    if (worksSliderX > 50) worksSliderX -= 50
    $worksSlider.css('transform', `translate3d(-${worksSliderX}%, 0, 0)`)

    requestAnimationFrame(updateWorksSlider)
  }
  updateWorksSlider()
}
